<script setup>
import { GCA_LOGO_URL_NAVY } from '@/services/marketing'
import { computed } from 'vue'
import { useAuthStore } from '@/store/auth'
import { useProfileStore } from '@/store/profile'
import { useRoute } from 'vue-router'
import AboutCTA from '@/components/AboutCTA.vue'
import LoginButton from '@/components/LoginButton.vue'
import ProfileChip from '@/components/ProfileChip.vue'
import SignupButton from '@/components/SignupButton.vue'

const { displayAuth } = defineProps({
  displayAuth: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const authStore = useAuthStore()
const profileStore = useProfileStore()
const route = useRoute()

const displayProfileChip = computed(() => {
  return authStore.isAuthenticated && !route.meta?.hideToolbarCTA
})
const displayAuthButtons = computed(() => {
  return displayAuth || !route.meta?.hideToolbarCTA
})
const displayAboutCTA = computed(() => {
  return authStore.isAuthenticated && !!profileStore.programLink
})
</script>

<template>
  <div class="toolbar">
    <router-link to="/">
      <img :src="GCA_LOGO_URL_NAVY" height="34" alt="Global Career Accelerator home" />
    </router-link>

    <div class="toolbar__right-side">
      <AboutCTA
        v-if="displayAboutCTA"
        :programLink="profileStore.programLink"
        :metaSalesforceId="profileStore.salesforceId || route.query?.sid"
        class="d-none d-lg-block"
      />
      <ProfileChip v-if="displayProfileChip" />
      <div v-else-if="displayAuthButtons">
        <LoginButton class="toolbar__login-btn" />
        <SignupButton />
      </div>
    </div>
  </div>
</template>

<style scoped>
.toolbar {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toolbar__right-side {
  display: flex;
  align-items: center;
  gap: 24px;
}

.toolbar__login-btn {
  margin-right: 12px;
}

@media (max-width: 1024px) {
  .toolbar__login-btn {
    display: none;
  }
}

@media (max-width: 430px) {
  .toolbar__login-btn {
    display: none;
  }
}
</style>
